/**
 * @fileOverview This file contains the implementation of the SiteAutocomplete component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { GlobalVariables } from '../../globalVar';
import customAxios from '../../utils/customAxios';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
//#endregion

const SiteAutocomplete = ({ clientId, setSite, siteIds }) => {
  const [sites, setSites] = useState([]);
  const [isClientSelected, setIsClientSelected] = useState(false);

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await customAxios.get(
          `${GlobalVariables.getURL()}autofillClientSites/${clientId}`,
          {
            headers: {
              Authorization: 'bearer ' + localStorage.getItem('token'),
            },
          }
        );
        setSites(response.data.filteredSites);
      } catch (error) {
        console.error('Error fetching sites:', error);
      }
    };

    if (clientId) {
      fetchSites();
      setIsClientSelected(true);
    } else {
      setSites([]);
      setIsClientSelected(false);
    }
  }, [clientId]);

  return (
    <Autocomplete
      options={sites}
      multiple
      disableCloseOnSelect
      limitTags={3}
      sx={{ width: '100%' }}
      getOptionLabel={(site) => site.site_name}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option.site_name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Seleccionar sucursal..."
          helperText={
            isClientSelected
              ? ''
              : 'Debes seleccionar una Plaza antes de elegir una sucursal'
          }
        />
      )}
      onChange={(event, newValue) => {
        setSite(newValue.map((site) => site.id));
      }}
      ListboxProps={{ style: { maxHeight: '15rem' } }}
      disabled={!isClientSelected}
    />
  );
};

export default SiteAutocomplete;
